import { acceptableUseSections } from "../../../content/legal";
import { PolicySectionList } from "../../legal/PolicySectionList";
import { PageTemplate } from "../../templates/PageTemplate";

export function AcceptableUsePage() {
  return (
    <PageTemplate
      id="acceptable-use-page"
      header={{
        kicker: "Acceptable Use",
        title: "Rules that protect users and the platform",
        description:
          "These restrictions are intended to protect users, the service, and CAD Guardian LLC's platform IP and operating integrity.",
      }}
    >
      <PolicySectionList sections={acceptableUseSections} />
    </PageTemplate>
  );
}
